/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ManagerFirstAidChecklist from "./managerTaskForms/manager-firstaid-checklist";
import ManagerCoshhProductCheckList from "./managerTaskForms/manager-cosh-product-checklist";
import ManagerKitchenChecklist from "./managerTaskForms/manager-kitchen-checklist";
import CreateEditDialog from "../../../common/dialog/create-edit-dialog";

const ManagerTaskForms = () => {
  const [checkDialogOpen, setCheckDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState(null);

  // Fetch tasks from redux store or API
  const tasks = [
    {
      taskName: "Kitchen Inspection",
      description: "Check cleanliness and stock levels in the kitchen.",
    },
    {
      taskName: "First Aid Kit Check",
      description: "Ensure first aid kit is fully stocked and not expired.",
    },
    {
      taskName: "COSHH Product Audit",
      description: "Review hazardous substance storage and documentation.",
    },
  ];

  const dialogComponents = {
    kitchen: ManagerKitchenChecklist,
    aid: ManagerFirstAidChecklist,
    product: ManagerCoshhProductCheckList,
  };

  const SelectedComponent = dialogComponents[dialogType] || null;

  return (
    <Grid container className='task-container'>
      <Grid item sm={8} className='task-list'>
        <Box sx={{ p: 4, ml: 2, mr: 1 }}>
          <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }} align='left'>
            {"Tasks > Task Forms"}
          </Typography>

          <Box className='scrollable-task-list'>
            {tasks.map((task, index) => (
              <Card
                key={index}
                sx={{
                  mb: 2,
                  color: "#ECECED",
                  cursor: "pointer",
                  border: "1px solid #ddd",
                }}
                onClick={() => {
                  if (!checkDialogOpen) {
                    const dialogMapping = {
                      kitchen: "kitchen",
                      aid: "aid",
                      product: "product",
                    };

                    const taskNameLower = task.taskName.toLowerCase();
                    const matchedType = Object.keys(dialogMapping).find((key) => taskNameLower.includes(key));

                    if (matchedType) {
                      setDialogType(dialogMapping[matchedType]);
                      setCheckDialogOpen(true);
                    } else {
                      setDialogType(null);
                      setCheckDialogOpen(false);
                    }
                  }
                }}
              >
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item lg={9} md={9} xs={12}>
                      <Grid container spacing={1} mb={1}>
                        <Grid item>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "black",
                              fontWeight: "bold",
                            }}
                          >
                            <FiberManualRecordIcon color='info' sx={{ fontSize: 10, mr: 1 }} />
                            {task.taskName}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Typography sx={{ fontSize: "12px", color: "black" }}>{task.description}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
                <CreateEditDialog isOpen={checkDialogOpen} maxWidth='xl' onClose={() => setCheckDialogOpen(false)}>
                  {SelectedComponent && <SelectedComponent onClose={() => setCheckDialogOpen(false)} />}
                </CreateEditDialog>
              </Card>
            ))}
          </Box>
        </Box>
      </Grid>

      <Grid item sm={4}></Grid>
    </Grid>
  );
};

export default ManagerTaskForms;
